'use strict';

define('vb/private/stateManagement/context/layoutBaseContext',[
  'vb/private/stateManagement/context/baseContext'],
(BaseContext) => {
  /**
   * set of properties to expose in $base for layout extension
   */
  class LayoutBaseContext extends BaseContext {
    /**
     * $base.layout
     */
    get layout() {
      return this;
    }
  }

  return LayoutBaseContext;
});

